import { useSelector } from 'react-redux';

import { selectors as helpCenterSelectors } from '../../../../redux/help-center-page';

const useArticle = () => useSelector(helpCenterSelectors.selectSelectedArticle);

const useSection = () =>
  useSelector(helpCenterSelectors.selectSelectedCategory);

const useSelectedArticleName = () =>
  useSelector(helpCenterSelectors.selectSelectedArticleName);

const useSelectedSubCategoryName = () =>
  useSelector(helpCenterSelectors.selectedSubCategoryName);

const hooks = {
  useArticle,
  useSelectedSubCategoryName,
  useSelectedArticleName,
  useSection,
};

export default hooks;
